import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AppRoutes from "./App.routes";
import Seo from '../../seo/Seo';

function App() {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      if (hash) {
        let id = hash.slice(1);
        try { id = decodeURIComponent(id); } catch { /* Keep malformed hashes harmless. */ }
        const section = document.getElementById(id);
        if (section) {
          section.setAttribute('tabindex', '-1');
          section.focus({ preventScroll: true });
          section.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      } else { window.scrollTo(0, 0); }
    });
    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash, key]);
  return <><Seo /><AppRoutes /></>;
}
export default App;
